<template>
    <div>
      <div class="footer">
        Copyright © 2012-2017  lnc.ALL Rights Reserve
      </div>
    </div>
</template>
<script>
    export default {
        name: '',
        data: () => ({}),
        methods: {},
//     dom挂载之后
        mounted() {
            this.$nextTick(() => {

            })
        },
        //    dom挂载之前
        created() {

        },
//    组件
        components: {},
//    计算函数
        computed: {}
    }
</script>
<style scoped lang="scss" type="text/scss">
  @import "../../style/css/helpers/mixin";

  .footer{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    background-color: #3f3f3f;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue